import Header from '../../components/Header'
import HeroSection from '../../components/landing/HeroSection'
import WhyChooseSection from '../../components/landing/WhyChooseSection'
import AboutSection from '../../components/landing/AboutSection'
import WhoWeServeSection from '../../components/landing/WhoWeServeSection'
import PricingCtaSection from '../../components/landing/PricingCtaSection'
import Footer from '../../components/landing/Footer'

const WaitList = () => {
  return (
    <div className='min-h-screen bg-[#FFFFFF] flex flex-col'>
      <Header />
      <main className='flex-1'>
        <HeroSection />
        <WhyChooseSection />
        <AboutSection />
        <WhoWeServeSection />
        <PricingCtaSection />
      </main>
      <Footer />
    </div>
  )
}

export default WaitList
